import React from 'react';
import styled from 'styled-components';

import { PaymentComponent_Item as PaymentListItem } from 'ggApp/modules/payment';

const ListContainer = styled.div`
    margin-bottom: 32px;
    & > * {
        margin-bottom: 24px;
    }
`;

const PaymentOptionsList = ({
    paymentOptions,
    onPaymentOptionClick,
    activePaymentOptionId,
    dark,
}) => (
    <ListContainer>
        {Array.isArray(paymentOptions)
            ? paymentOptions.map(({ name, id }) => (
                  <PaymentListItem
                      dark={dark}
                      key={id}
                      active={id === activePaymentOptionId}
                      paymentMethod={{ id, name }}
                      onClick={() => onPaymentOptionClick(id)}
                  />
              ))
            : null}
    </ListContainer>
);

export default PaymentOptionsList;
